<div
  class="row-container"
  [ngbPopover]="tooltipTemplate"
  [openDelay]="300"
  [closeDelay]="300"
  triggers="mouseenter:mouseleave"
  container="body"
  popoverClass="rask-icon-popover"
  >
  <rask-arbetsorder-info-icon [arbetsorder]="arbetsorder" [useImage]="true"></rask-arbetsorder-info-icon>
  <span>
    {{ input.naturalKey }} -
    {{ input.title }}
  </span>
  @if (input.metadata['totalKvantitet'] !== null) {
    <span>
      <br />
      <span class="left-margin w45">{{ input.metadata["totalKvantitet"] }} m3fub</span>
    </span>
  }
</div>
